// powerpoint.service.ts
import { Injectable } from '@angular/core';
import pptxgen from "pptxgenjs";
import { PowerPointTableData, TableConfigurations } from './types/powerpoint.types';

@Injectable({
  providedIn: 'root',
})
export class PowerpointService {
  constructor() {}

  generateSlides(slideDataArray: PowerPointTableData[], config: TableConfigurations, filename: string) {
    const pptx = new pptxgen();

    slideDataArray.forEach((slideData) => {
      this.createTableSlide(pptx, slideData, config);
    });

    pptx.writeFile({ fileName: filename })
      .then(fileName => {
          console.log(`created file: ${fileName}`);
      });
  }

  createTableSlide(pptx: any, slideData: PowerPointTableData, config: TableConfigurations) {
    /**
     * pptx: powerpoint instance
     * slideData: data to be exported
     * configuration: TableConfigurations
     */

    const totalRows = slideData.data.length;
    let startIndex = 0;

    while (startIndex < totalRows) {
      const slide = pptx.addSlide();

      slide.addText(slideData.title, { x: 0.25, y: 0.35, fontSize: 21, color: '000000' });
      slide.addText(slideData.subtitle, { x: 0.25, y: 0.65, fontSize: 18, color: '53565A' });
      const endIndex = Math.min(startIndex + config.maxTableRowsPerSlide, totalRows);

      const genrealHeaderOptions = {bold: true, color:'26890D', border: [{ pt: 3, color:'92BB44'}, null, {pt: 0.5, color:'CCCDCD'}, null]};
      const genrealBodyOptions = {border: [null, null, {pt: 0.5, color:'CCCDCD'}, null]};

      const tableData = [
        config.headers.map(header => {
          return {
            text: header, options: {...genrealHeaderOptions, ...config.headerOptions[header.toLowerCase()]}
          }
        }),
        ...slideData.data.slice(startIndex, endIndex).map((item) => Object.keys(config.options).map(val => {
          if (Array.isArray(item[val])) {
            return {
              text: item[val].map(text => {
                return {
                  text: text
                };
              }),
              options: {...genrealBodyOptions, ...config.options[val]}
            }
          } else {
            return {
              text: item[val],
              options: {...genrealBodyOptions, ...config.options[val]}
            }
          }
        }))
      ];

      slide.addTable(tableData, { x: 0.25, y: 1.2, w: 6, h: 2, colW: config.columnWidth, fontSize: 10, fontFace:'Calibri' });

      startIndex = endIndex;
    }

    return pptx;
  }
}
